import React, { useState } from 'react';
import {
  PERSONAL_DATA,
  AU_IDENTIFICATION_TYPES,
} from '@/constants/personalData';
import RadioButtonController from '@/components/radioButtonController';
import { LABEL_SIZE, LABEL_COLOR } from '@/components/radioButton';
import FormTemplate, { THEMES } from '@/components/formTemplate';
import PersonalData from '@/containers/personalData';
import PersonalDataAU from '@/containers/personalDataAU';
import Text, { TEXT_COLOR, TEXT_SIZE } from '@/bit/components/components.text';

function ChoosePersonalData({ control, showRadioInput = false }) {
  const [identificationTypeSelected, setIdentificationTypeSelected] = useState({
    value: AU_IDENTIFICATION_TYPES.AU_IDENTIFICATION_TYPE_NIF.value,
  });
  const handleOnChange = ({ value }) => {
    setIdentificationTypeSelected(value);
  };
  const { AU_IDENTIFICATION_TYPE, TITLE_AU, ID } = PERSONAL_DATA;
  return (
    <>
      {showRadioInput && (
        <div className="choose-personal-data-container">
          <FormTemplate titleText={TITLE_AU} cyData={ID} theme={THEMES.FULL}>
            <div className="choose-personal-data__text">
              <Text
                text="¿Cómo te vas a identificar?"
                size={TEXT_SIZE.CAPTION1}
                color={TEXT_COLOR.GREY5}
                cyData={`${ID}__au_text`}
              />
            </div>

            <RadioButtonController
              inputName={AU_IDENTIFICATION_TYPE.NAME}
              inputId={AU_IDENTIFICATION_TYPE.ID}
              control={control}
              rules={{
                required: AU_IDENTIFICATION_TYPE.RULES.REQUIRED,
              }}
              label={AU_IDENTIFICATION_TYPE.LABEL}
              options={AU_IDENTIFICATION_TYPE.OPTIONS}
              handleOnChange={handleOnChange}
              withBox={false}
              withCheck
              defaultValue={{
                value: AU_IDENTIFICATION_TYPES.AU_IDENTIFICATION_TYPE_NIF.value,
              }}
              labelSize={LABEL_SIZE.CAPTION1}
              labelColor={LABEL_COLOR.GREY5}
            />
          </FormTemplate>
        </div>
      )}
      {identificationTypeSelected?.value ===
        AU_IDENTIFICATION_TYPES.AU_IDENTIFICATION_TYPE_NIF.value && (
        <PersonalData control={control} showTitle={!showRadioInput} />
      )}
      {identificationTypeSelected?.value ===
        AU_IDENTIFICATION_TYPES.AU_IDENTIFICATION_TYPE_CIF.value && (
        <PersonalDataAU control={control} showTitle={!showRadioInput} />
      )}

      <style jsx>
        {`
          .choose-personal-data-container {
            position: relative;
            display: flex;
            flex-direction: column;
            padding-bottom: 4px;
            .choose-personal-data-container--row {
              max-width: 100%;
              display: flex;
              flex-direction: row;
              justify-content: space-between;
            }
            .choose-personal-data__text {
              margin-bottom: 8px;
            }
          }
        `}
      </style>
    </>
  );
}
export default ChoosePersonalData;
